import PageHeader from "@/components/PageHeader";
import { BookOpen } from "lucide-react";

const ITEMS = [
  {
    code: "M1021",
    title: "Primary Diagnosis",
    description: "The chief reason the patient is receiving home care. Only one ICD-10-CM code allowed.",
    rule: "Single code · Required",
  },
  {
    code: "M1023",
    title: "Other Diagnoses",
    description: "Up to 25 additional diagnoses (slots A–Z) that affect the patient's plan of care.",
    rule: "0–25 codes · A–Z",
  },
  {
    code: "M1028",
    title: "Active Diagnoses — Comorbidities",
    description: "Identifies whether peripheral vascular disease, diabetes mellitus, etc. are active diagnoses.",
    rule: "Checklist",
  },
  {
    code: "M1030",
    title: "Therapies",
    description: "Therapies received at home: IV/Infusion, Parenteral nutrition, Enteral nutrition.",
    rule: "Checklist",
  },
  {
    code: "M1033",
    title: "Risk for Hospitalization",
    description: "Patient characteristics that put them at greater risk for hospitalization.",
    rule: "Checklist",
  },
  {
    code: "M1311",
    title: "Number of Unhealed Pressure Ulcers / Injuries",
    description: "Count of pressure ulcers/injuries by stage.",
    rule: "Counts by stage",
  },
  {
    code: "M1322",
    title: "Stage 1 Pressure Injuries",
    description: "Current number of Stage 1 pressure injuries.",
    rule: "Numeric",
  },
  {
    code: "M1400",
    title: "When Short of Breath",
    description: "Patient's level of dyspnea at the time of assessment.",
    rule: "Single select",
  },
  {
    code: "M1610",
    title: "Urinary Incontinence",
    description: "Presence and pattern of urinary incontinence.",
    rule: "Single select",
  },
  {
    code: "M1620",
    title: "Bowel Incontinence Frequency",
    description: "How often the patient experiences bowel incontinence.",
    rule: "Single select",
  },
  {
    code: "M1800",
    title: "Grooming",
    description: "Patient's ability to tend to personal hygiene needs.",
    rule: "Single select",
  },
  {
    code: "M1860",
    title: "Ambulation / Locomotion",
    description: "Patient's ability to walk safely on a variety of surfaces.",
    rule: "Single select",
  },
];

export default function OasisItems() {
  return (
    <div className="p-6 md:p-10 max-w-6xl mx-auto" data-testid="oasis-items-page">
      <PageHeader
        title="OASIS Items"
        subtitle="Quick reference for OASIS-E data items used in coding."
      />

      <div className="bg-sky-50 border border-sky-200 rounded-xl p-4 mb-6 flex items-start gap-3" data-testid="oasis-info-banner">
        <BookOpen size={18} className="text-sky-700 mt-0.5 shrink-0" />
        <div className="text-sm text-sky-900">
          OASIS (Outcome and Assessment Information Set) is the standardized assessment used for Medicare-certified home health agencies.
          Coders capture diagnosis items (M1021, M1023) on every chart submission; the items below are a quick reference for the most common fields encountered during review.
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="oasis-items-grid">
        {ITEMS.map((it) => (
          <div key={it.code} className="bg-white border border-slate-200 rounded-xl p-5 hover:border-sky-200 transition-colors" data-testid={`oasis-item-${it.code}`}>
            <div className="flex items-center justify-between mb-2">
              <span className="font-mono text-sm font-semibold bg-sky-50 text-sky-800 border border-sky-200 rounded px-2 py-0.5">
                {it.code}
              </span>
              <span className="text-[10px] uppercase tracking-widest text-slate-500">{it.rule}</span>
            </div>
            <h3 className="font-heading text-base font-medium text-slate-900 mb-1.5">{it.title}</h3>
            <p className="text-sm text-slate-600 leading-relaxed">{it.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
